import getWeek from 'utils/time/getWeek';
import getDay from 'utils/time/getDay';
import setDay from 'utils/time/setDay';
import getYear from 'utils/time/getYear';
import setYear from 'utils/time/setYear';
import setWeek from 'utils/time/setWeek';

function addYearsPreserveWeekAndDay(prevDate: Date, years: number): Date {
  // be careful for the first/last few days of the year because of the week numbering rules
  // https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
  // i.e. if you try to set week 53 of a year that doesn't have 53 weeks, it will be wrong
  // but it should not be a big deal for us
  // otherwise, try setISOWeekYear(prevDate, getYear(prevDate) + years);

  const woy = getWeek(prevDate, false);
  const dow = getDay(prevDate);
  const year = getYear(prevDate) + years;

  const result = setDay(
    setWeek(setYear(prevDate, year), woy, false),
    dow,
    false,
  );
  if (getYear(result) !== year) {
    // best effort : ignore week number when it interfers with expected year
    return setDay(setYear(result, year), dow, false);
  }
  return result;
}

export { addYearsPreserveWeekAndDay };
